// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"a069d5ca","977":"63ad852d"}[chunkId] + ".chunk.js";
};